import { Button as AntDButton } from "antd";
import "./Button.scss";

interface ButtonProps {
  text: string;
  type?: ButtonType;
  size?: ButtonSize;
  isLoading?: boolean;
  htmlType?: ButtonHtmlType;
}

export enum ButtonType {
  PRIMARY = "primary",
  TEXT = "text",
  LINK = "link",
  DEFAULT = "default",
  DASHED = "dashed",
}

export enum ButtonSize {
  SMALL = "small",
  LARGE = "large",
}

export enum ButtonHtmlType {
  BUTTON = "button",
  SUBMIT = "submit",
  RESET = "reset",
}

export const Button = ({
  text,
  size,
  type,
  isLoading,
  htmlType,
}: ButtonProps) => {
  return (
    <AntDButton
      size={size}
      htmlType={htmlType}
      type={type}
      className="cp-button"
      loading={isLoading}
    >
      {text}
    </AntDButton>
  );
};

export default Button;
